import React, {useState} from 'react';
import FileTableRow from './FileTableRow.mjs';
import './FileTable.css';

export default function FileTable({files, margin_top}) 
{
    if ((!files) || (files.length == 0)) return; 

    return (
        <>
            <table id="file-table" class={"table "+margin_top}>
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Filename</th>
                    <th scope="col">Size</th>
                    <th scope="col">Age</th>
                    <th scope="col"></th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    { files?.map( (file, i) => ( <FileTableRow file={file} key={i} file_ndx={i}/> )) }
                </tbody>
            </table>
        </>
    );
}